import { useQuery } from '@tanstack/react-query';

import { seasonDivisionPoolKeys } from '@/hooks/leagueSeasonDivision/seasonDivisionPoolKeys';
import { getSeasonDivisionPoolData } from '@/infrastructure/network/data/season';
import { SeasonDivisionPoolData } from '@/infrastructure/network/dto/SeasonDivisionPool';

export const useSeasonDivisionPoolData = (poolUuid: string) => {
	return useQuery<SeasonDivisionPoolData>({
		queryKey: seasonDivisionPoolKeys.pool(poolUuid),
		queryFn: async () => {
			const response = await getSeasonDivisionPoolData({ poolUuid });
			return response.data;
		},
		enabled: !!poolUuid
	});
};
